import * as Types from '../generatedTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type RemoveAppTranslationMutationVariables = Types.Exact<{
  id: Types.Scalars['ID'];
}>;


export type RemoveAppTranslationMutation = { __typename?: 'Mutation', removeAppTranslation: boolean };


export const RemoveAppTranslationDocument = gql`
    mutation removeAppTranslation($id: ID!) {
  removeAppTranslation(id: $id)
}
    `;
export type RemoveAppTranslationMutationFn = Apollo.MutationFunction<RemoveAppTranslationMutation, RemoveAppTranslationMutationVariables>;

/**
 * __useRemoveAppTranslationMutation__
 *
 * To run a mutation, you first call `useRemoveAppTranslationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useRemoveAppTranslationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [removeAppTranslationMutation, { data, loading, error }] = useRemoveAppTranslationMutation({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useRemoveAppTranslationMutation(baseOptions?: Apollo.MutationHookOptions<RemoveAppTranslationMutation, RemoveAppTranslationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<RemoveAppTranslationMutation, RemoveAppTranslationMutationVariables>(RemoveAppTranslationDocument, options);
      }
export type RemoveAppTranslationMutationHookResult = ReturnType<typeof useRemoveAppTranslationMutation>;
export type RemoveAppTranslationMutationResult = Apollo.MutationResult<RemoveAppTranslationMutation>;
export type RemoveAppTranslationMutationOptions = Apollo.BaseMutationOptions<RemoveAppTranslationMutation, RemoveAppTranslationMutationVariables>;